import { useBaseFilter } from '../../../hooks/useFilter';

export function useSheetsFilters() {
  const { baseFilters } = useBaseFilter();

  return {
    timesheetsFilterItems: baseFilters,
  };
}
